import React from "react";
import Footer from "../components/footer";
import FAQS from "../components/features/feature_faq";
import FeatureItem from "../components/features/feature-item";
import { useLocation } from "react-router-dom";

const FeatureReview = (feat) => {
    const location = useLocation();
    const ft = location.state?.feat;

    return (
        <div>
            {console.log("Navigated to /feature with ft:", ft)};
            <FeatureItem ft={ft} />
            <FAQS name={ft} />
            <Footer />
        </div>
    );
};

export default FeatureReview;
